import * as React from 'react';
import './VerifyPasswordView.scss';
import ForgotPassword from '../ForgotPasswordView/components/ForgotPassword';

export function VerifyPasswordView() {
  return (
    <div className="rp-verifypasswordview">
      <ForgotPassword mode="verify" />
    </div>
  );
}
